import { render, staticRenderFns } from "./TableRowNumTestsPerTech.vue?vue&type=template&id=100ea34c&lang=pug&"
import script from "./TableRowNumTestsPerTech.vue?vue&type=script&lang=js&"
export * from "./TableRowNumTestsPerTech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('100ea34c')) {
      api.createRecord('100ea34c', component.options)
    } else {
      api.reload('100ea34c', component.options)
    }
    module.hot.accept("./TableRowNumTestsPerTech.vue?vue&type=template&id=100ea34c&lang=pug&", function () {
      api.rerender('100ea34c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/performance-evaluation/table-rows/TableRowNumTestsPerTech.vue"
export default component.exports